:host {
  display: block;

  &[orientation="vertical"] {
    display: flex;
    height: 100%;
  }

  .br-divider {
    align-items: center;
    background-color: transparent;
    border: none;
    display: flex;
    justify-content: space-between;
    margin: var(--divider-margin-top, 20px) var(--divider-margin-right, 0) var(--divider-margin-bottom, 20px)
      var(--divider-margin-left, 0);

    &::before,
    &::after {
      content: "";
      flex: 1;
      border-top: var(--divider-size, 1px) solid var(--border-color, black);
    }

    &.dashed {
      border-top: none;
      background: none;

      &::before,
      &::after {
        border-top: var(--divider-size, 1px) dashed var(--border-color);
      }
    }

    &.dashed.vertical {
      border-right: var(--divider-size, 1px) dashed var(--border-color);
      border-top: none;

      &::before,
      &::after {
        border-right: var(--divider-size, 1px) dashed var(--border-color);
        border-top: none;
      }
    }

    &.vertical {
      flex-direction: column;
      height: 100%;
      width: auto;
      margin: var(--divider-margin-top, 0) var(--divider-margin-right, 10px) var(--divider-margin-bottom, 0)
        var(--divider-margin-left, 10px);
      align-self: stretch;
      border-right-width: var(--divider-size);
      border-top-width: 0;

      &::before,
      &::after {
        border-right: var(--divider-size, 1px) solid var(--border-color, black);
        border-top: none;
        margin: 0;
      }
    }

    &.small {
      --divider-size: var(--surface-width-sm);
    }

    &.medium {
      --divider-size: var(--surface-width-md);
    }

    &.large {
      --divider-size: var(--surface-width-lg);
    }

    &.divider-start {
      justify-content: flex-start;

      &::before {
        flex: 0 0 0px;
        margin-right: var(--spacing-scale-base);
      }
    }

    &.divider-center {
      justify-content: center;
    }

    &.divider-end {
      justify-content: flex-end;

      &::after {
        flex: 0 0 0px;
        margin-left: var(--spacing-scale-base);
      }
    }

    &.dark-mode {
      --border-color: var(--pure-0);
    }

    .divider-start::after,
    .divider-center::before,
    .divider-center::after,
    .divider-end::before {
      margin: 0 var(--spacing-scale-base);
    }

    .divider-start::before {
      margin-right: var(--spacing-scale-base);
    }

    .divider-end::after {
      margin-left: var(--spacing-scale-base);
    }
  }
}
